<template>
  <main class="w-full flex-grow p-6">
    <div class="w-full lg:w-full my-6 pr-0 lg:pr-2 mb-10">
      <div class="leading-loose">
        <div class="p-5 bg-white rounded shadow-xl">
          <div class="flex justify-between border-b-2 mb-5 pb-5">
            <div class="font-bold text-2xl">
              Tenant Header (600 px X 400 px)
            </div>
            <div @click="showModalBanner" class="mr-5 cursor-pointer">
              <fas icon="pencil-alt" class="text-app-default text-2xl" />
            </div>
          </div>
          <div class="flex">
            <img
              :src="tenantBanner.banner"
              @click="showModal(tenantBanner.banner)"
              alt="23paskal-tenant-banner"
              class="w-64 h-36 cursor-pointer"
            />
          </div>
        </div>
      </div>
    </div>

    <button
      @click="showModalTenant"
      class="block px-3 h-9 hover:text-white focus:ring focus:ring-primary-default focus:ring-opacity-30 focus:outline-none rounded-md text-sm bg-app-default hover:bg-app-light text-white mb-3 font-bold"
    >
      Add New Tenant
    </button>

    <div class="w-full lg:w-1/4 pr-0 lg:pr-2">
      <input
        v-model="table.search"
        @keyup="searchSubscriber"
        type="text"
        class="w-full h-9 px-2 rounded-md border-2 border-gray-200 focus:outline-none focus:ring transition duration-200 mb-5"
        placeholder="Search name"
      />
    </div>

    <div class="mb-5">
      <table class="w-full mx-auto table-auto">
        <thead class="justify-between">
          <tr class="bg-gray-600">
            <th class="px-5 py-2">
              <span class="text-gray-100 font-semibold">No</span>
            </th>
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Name</span>
            </th>
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Email</span>
            </th>
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Telephone</span>
            </th>
            <!-- <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Floor</span>
            </th> -->
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Avatar</span>
            </th>
            <th class="px-16 py-2">
              <span class="text-gray-100 font-semibold">Option</span>
            </th>
          </tr>
        </thead>
        <tbody class="bg-gray-200">
          <tr
            v-for="(sos, index) in rows"
            :key="sos.id"
            :class="[index % 2 !== 0 ? 'bg-gray-200' : '']"
            class="bg-white border-b-2 border-gray-200"
          >
            <td class="px-5 py-2 text-center">
              {{
                table.current_page === 1
                  ? index + 1
                  : index + 1 + (table.current_page - 1) * table.per_page
              }}
            </td>
            <td class="text-center">
              <span class="font-semibold">
                {{ sos.tenant_name }}
              </span>
            </td>
            <td class="text-center">
              <span class="font-semibold">
                {{ sos.tenant_email }}
              </span>
            </td>
            <td class="text-center">
              <span class="font-semibold">
                {{ sos.tenant_telephone }}
              </span>
            </td>
            <!-- <td class="text-center">
              <span class="font-semibold">
                {{ sos.floor_name }}
              </span>
            </td> -->
            <td class="p-2">
              <div class="flex items-center justify-center">
                <img
                  class="w-10 h-10 cursor-pointer"
                  @click="showModal(sos.tenant_image)"
                  :src="sos.tenant_image"
                  alt="23paskal"
                />
              </div>
            </td>
            <td class="">
              <div class="flex items-center justify-evenly">
                <button class="" type="button" @click="detailContent(sos.id)">
                  <!-- <fas icon="eye" class="text-app-default text-3xl" /> -->
                  <span class="font-bold text-app-default">
                    More
                  </span>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
      <div>
        <p class="text-sm text-gray-700">
          Showing
          <span class="font-medium">
            {{ table.current_page * table.per_page - table.per_page + 1 }}
          </span>
          to
          <span class="font-medium">
            {{ table.current_page * table.per_page }}
          </span>
          of
          <span class="font-medium">{{ table.total }}</span>
          results
        </p>
      </div>
      <div>
        <nav
          class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
          aria-label="Pagination"
        >
          <button
            type="button"
            @click="previewPage"
            :disabled="table.current_page === 1"
            class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
          >
            <span class="sr-only">Previous</span>
            <svg
              class="h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
          <div v-if="Math.ceil(table.total / table.per_page) < 5" class="">
            <button
              v-for="pg in Math.ceil(table.total / table.per_page)"
              :key="pg"
              @click="findpage(pg)"
              type="button"
              aria-current="page"
              class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
              :class="[
                table.current_page === pg
                  ? 'bg-app-default text-white'
                  : 'bg-white text-black',
              ]"
            >
              {{ pg }}
            </button>
          </div>
          <div v-else class="">
            <button
              @click="findpage(1)"
              type="button"
              aria-current="page"
              class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
              :class="[
                table.current_page === 1
                  ? 'bg-app-default text-white'
                  : 'bg-white text-black',
              ]"
            >
              1
            </button>

            <button
              @click="
                findpage(
                  table.current_page === 1
                    ? 2
                    : table.current_page === 2
                    ? 2
                    : table.current_page ===
                      Math.ceil(table.total / table.per_page)
                    ? table.current_page - 3
                    : table.current_page ===
                      Math.ceil(table.total / table.per_page) - 1
                    ? table.current_page - 2
                    : table.current_page - 1
                )
              "
              type="button"
              aria-current="page"
              :disabled="
                Math.ceil(table.total / table.per_page) - 1 ===
                  table.current_page
              "
              class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
              :class="[
                table.current_page === 1
                  ? 'bg-white text-black'
                  : table.current_page === 2
                  ? 'bg-app-default text-white'
                  : 'bg-white text-black',
              ]"
            >
              {{
                table.current_page === 1
                  ? 2
                  : table.current_page === 2
                  ? 2
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page)
                  ? table.current_page - 3
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page) - 1
                  ? table.current_page - 2
                  : table.current_page - 1
              }}
            </button>

            <button
              @click="
                findpage(
                  table.current_page === 1
                    ? 3
                    : table.current_page === 2
                    ? 3
                    : table.current_page ===
                      Math.ceil(table.total / table.per_page) - 1
                    ? table.current_page - 1
                    : table.current_page ===
                      Math.ceil(table.total / table.per_page)
                    ? table.current_page - 2
                    : table.current_page
                )
              "
              type="button"
              aria-current="page"
              :disabled="
                Math.ceil(table.total / table.per_page) - 1 ===
                  table.current_page
              "
              class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
              :class="[
                table.current_page ===
                Math.ceil(table.total / table.per_page) - 1
                  ? 'bg-white text-black'
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page)
                  ? 'bg-white text-black'
                  : table.current_page === 1
                  ? 'bg-white text-black'
                  : table.current_page === 2
                  ? 'bg-white text-black'
                  : 'bg-app-default text-white',
              ]"
            >
              {{
                table.current_page === 1
                  ? 3
                  : table.current_page === 2
                  ? 3
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page) - 1
                  ? table.current_page - 1
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page)
                  ? table.current_page - 2
                  : table.current_page
              }}
            </button>

            <button
              @click="
                findpage(
                  table.current_page === 1
                    ? 4
                    : table.current_page === 2
                    ? 4
                    : table.current_page ===
                      Math.ceil(table.total / table.per_page) - 1
                    ? Math.ceil(table.total / table.per_page) - 1
                    : table.current_page ===
                      Math.ceil(table.total / table.per_page)
                    ? table.current_page - 1
                    : table.current_page + 1
                )
              "
              type="button"
              aria-current="page"
              :disabled="
                Math.ceil(table.total / table.per_page) - 1 ===
                  table.current_page
              "
              class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
              :class="[
                table.current_page ===
                Math.ceil(table.total / table.per_page) - 2
                  ? 'bg-white text-black'
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page) - 3
                  ? 'bg-white text-black'
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page)
                  ? 'bg-white text-black'
                  : table.current_page > 1 &&
                    table.current_page <
                      Math.ceil(table.total / table.per_page) - 1
                  ? 'bg-white text-black'
                  : table.current_page === 1
                  ? 'bg-white text-black'
                  : 'bg-app-default text-white',
              ]"
            >
              {{
                table.current_page === 1
                  ? 4
                  : table.current_page === 2
                  ? 4
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page) - 1
                  ? Math.ceil(table.total / table.per_page) - 1
                  : table.current_page ===
                    Math.ceil(table.total / table.per_page)
                  ? table.current_page - 1
                  : table.current_page + 1
              }}
            </button>

            <button
              @click="findpage(Math.ceil(table.total / table.per_page))"
              type="button"
              aria-current="page"
              class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium"
              :class="[
                table.current_page === Math.ceil(table.total / table.per_page)
                  ? 'bg-app-default text-white'
                  : 'bg-white text-black',
              ]"
            >
              {{ Math.ceil(table.total / table.per_page) }}
            </button>
          </div>
          <!-- <button v-for="pg in Math.ceil(table.total / table.per_page)" :key="pg" @click="findpage(pg)" type="button" aria-current="page" class="z-10 border-indigo-500 relative inline-flex items-center px-4 py-2 border text-sm font-medium" :class="[table.current_page === pg ? 'bg-app-default text-white' : 'bg-white text-black']">
            {{ pg }}
          </button> -->
          <button
            type="button"
            @click="nexPage"
            :disabled="
              Math.ceil(table.total / table.per_page) === table.current_page
            "
            class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50"
          >
            <span class="sr-only">Next</span>
            <svg
              class="h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </nav>
      </div>
    </div>

    <!-- Modal Banner -->
    <div
      v-if="modalBanner"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed flex items-center"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 400px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <button
            @click.self="showModalBanner"
            class="fill-current h-6 w-6 absolute right-0 top-0 m-6 font-3xl font-bold"
          >
            &times;
          </button>
          <div class="px-6 py-3 text-xl border-b font-bold">
            Tenant Header (600 px X 400 px)
          </div>
          <div class="p-6 flex-grow">
            <div
              class="border-dotted border-2 border-black p-2 rounded-lg"
              @drop="previewBanner"
            >
              <input
                type="file"
                accept="image/*"
                @change="previewBanner"
                id="banner"
                class="opacity-0 hidden"
              />
              <div class="flex flex-row">
                <div
                  v-if="update.previewBanner"
                  class="mr-1 relative rounded-lg w-full"
                >
                  <button
                    class="absolute right-2 top-2"
                    type="button"
                    @click="removeBannerFile"
                  >
                    <fas icon="trash-alt" class="text-red-600 text-3xl" />
                  </button>
                  <img
                    :src="update.previewBanner"
                    class="w-full h-48 rounded-lg"
                  />
                </div>
                <div
                  v-if="update.previewBanner === null"
                  v-cloak
                  @click="chooseBannerFile()"
                  class="w-full h-48 mr-1 rounded-lg cursor-pointer bg-gray-200 flex items-center justify-center"
                >
                  <fas icon="image" class="text-gray-600 text-3xl" />
                </div>
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="showModalBanner"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Close
              </button>
              <button
                :disabled="!update.previewBanner"
                @click="updateBannerTenant"
                type="button"
                class="text-gray-200 rounded px-4 py-2 w-32"
                :class="[!update.previewBanner ? 'bg-gray-500' : 'bg-blue-600']"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="showModalBanner"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>

    <!-- modal create -->
    <div
      v-if="modalTenant"
      class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed"
    >
      <div
        class="z-50 relative p-3 mx-auto my-0 max-w-full"
        style="width: 800px;"
      >
        <div
          class="bg-white rounded shadow-lg border flex flex-col overflow-hidden"
        >
          <div class="flex flex-row border-b items-center justify-between">
            <div class="px-6 py-3 text-xl font-bold">Add New Tenant</div>
            <div class="">
              <button
                @click.self="closeModalTenant"
                class="font-3xl font-bold p-6"
              >
                &times;
              </button>
            </div>
          </div>
          <div class="p-6 flex-grow">
            <div class="w-full pr-0 lg:pr-2">
              <label class="font-semibold text-black opacity-80"
                >Tenant Status</label
              >
              <div class="flex flex-row items-center h-9 mb-5">
                <div
                  class="relative cursor-pointer"
                  @click="create.tenant_active = !create.tenant_active"
                >
                  <div
                    class="w-10 h-4 bg-gray-400 rounded-full shadow-inner items-center p-1 duration-300 ease-in-out"
                    :class="{ 'bg-app-default': create.tenant_active }"
                  ></div>
                  <div
                    class="absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition transform duration-300 ease-in-out"
                    :class="{ 'translate-x-6': create.tenant_active }"
                  ></div>
                </div>
              </div>
            </div>
            <label class="font-semibold text-black opacity-80"
              >Image (1020 px X 1020 px)</label
            >
            <div class="w-52">
              <div
                class="border-dotted border-2 p-2 rounded-lg"
                :class="[
                  errors.tenant_image ? 'border-red-400' : 'border-black',
                ]"
                @drop="previewImageTenant"
              >
                <input
                  type="file"
                  accept="image/jpeg, image/jpg"
                  @change="previewImageTenant"
                  id="tenant_file"
                  class="opacity-0 hidden"
                />
                <div class="flex flex-row">
                  <div
                    v-if="previewFileTenant"
                    class="mr-1 relative rounded-lg w-full"
                  >
                    <button
                      class="absolute right-2 top-2"
                      type="button"
                      @click="removeTenantFile()"
                    >
                      <fas icon="trash-alt" class="text-red-600 text-3xl" />
                    </button>
                    <img
                      :src="previewFileTenant"
                      class="w-full h-52 rounded-lg"
                    />
                  </div>
                  <div
                    v-if="previewFileTenant === null"
                    v-cloak
                    @click="chooseSingleFile()"
                    class="w-full h-52 mr-1 rounded-lg cursor-pointer bg-gray-200 flex items-center justify-center"
                  >
                    <fas icon="image" class="text-gray-600 text-3xl" />
                  </div>
                </div>
              </div>
              <div class="text-sm text-red-600 mb-5">
                {{ errors.tenant_image_msg }}
              </div>
            </div>

            <label class="font-semibold text-black opacity-80"
              >Denah Location (1200 px X 500 px)</label
            >
            <div class="">
              <div
                class="border-dotted border-2 p-2 rounded-lg"
                :class="[
                  errors.tenant_denah_position
                    ? 'border-red-400'
                    : 'border-black',
                ]"
                @drop="previewImageLocation"
              >
                <input
                  type="file"
                  accept="image/jpeg, image/jpg"
                  @change="previewImageLocation"
                  id="location_file"
                  class="opacity-0 hidden"
                />
                <div class="flex flex-row">
                  <div
                    v-if="previewFileLocation"
                    class="mr-1 relative rounded-lg w-full"
                  >
                    <button
                      class="absolute right-2 top-2"
                      type="button"
                      @click="removeFileLocation()"
                    >
                      <fas icon="trash-alt" class="text-red-600 text-3xl" />
                    </button>
                    <img
                      :src="previewFileLocation"
                      class="w-full h-52 rounded-lg"
                    />
                  </div>
                  <div
                    v-if="locationFileList === null"
                    v-cloak
                    @click="chooseFileLocation()"
                    class="w-full h-52 mr-1 rounded-lg cursor-pointer bg-gray-200 flex items-center justify-center"
                  >
                    <fas icon="image" class="text-gray-600 text-3xl" />
                  </div>
                </div>
              </div>
              <div class="text-sm text-red-600 mb-5">
                {{ errors.tenant_denah_position_msg }}
              </div>
            </div>

            <div class="flex flex-wrap">
              <Select
                :selectItem="selectItem"
                :data="dropDown.dataSelect"
                :open="dropDown.isOpen"
                :selected="dropDown.selected"
                :openSelect="openSelect"
                :id="create.tenan_category_id"
                :isError="errors.tenan_category_id"
                :errorMessage="errors.tenan_category_id_msg"
                :title="dropDown.title"
              />

              <div class="w-full lg:w-1/2 pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Tenant Name</label
                >
                <input
                  v-model="create.tenant_name"
                  @keyup="tenantNameChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.tenant_name
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Tenant Name"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.tenant_name_msg }}
                </div>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Tenant Telephone</label
                >
                <input
                  v-model="create.tenant_telephone"
                  @keyup="tenantTelephoneChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.tenant_telephone
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Tenant Telephone"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.tenant_telephone_msg }}
                </div>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Tenant Email</label
                >
                <input
                  v-model="create.tenant_email"
                  @keyup="tenantEmailChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.tenant_email
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Tenant Email"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.tenant_email_msg }}
                </div>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Tenant Website</label
                >
                <input
                  v-model="create.tenant_website"
                  @keyup="tenantWebsiteChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.tenant_website
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Tenant Website"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.tenant_website_msg }}
                </div>
              </div>
              <div class="w-full lg:w-1/2 pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Tenant Website Mall To GO</label
                >
                <input
                  v-model="create.tenant_website_mall_to_go"
                  @keyup="tenantWebsiteMallToGoChange"
                  type="text"
                  class="w-full h-9 px-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.tenant_website_mall_to_go
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Tenant Website Mall To GO"
                />
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.tenant_website_mall_to_go_msg }}
                </div>
              </div>
              <Select
                :selectItem="floorSelectItem"
                :data="floorDropDown.dataSelect"
                :open="floorDropDown.isOpen"
                :selected="floorDropDown.selected"
                :openSelect="floorOpenSelect"
                :id="create.tenant_floor_location"
                :isError="errors.tenant_floor_location"
                :errorMessage="errors.tenant_floor_location_msg"
                :title="floorDropDown.title"
              />

              <div class="w-full pr-0 lg:pr-2">
                <label class="font-semibold text-black opacity-80"
                  >Tenant Description</label
                >
                <!-- <textarea v-model="create.tenant_description" rows="5" class="w-full pl-3 pr-3 py-2 rounded-md border-2 border-gray-200 focus:outline-none focus:ring transition duration-200  mb-4" placeholder="Denant Description"></textarea> -->
                <div
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.tenant_description
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                >
                  <CKEditor
                    v-model="create.tenant_description"
                    :disabled="false"
                    :toolbar="toolbar"
                    @onChange="tenantDescriptionChange"
                  />
                </div>
                <!-- <div
                  style="list-style: decimal;"
                  v-html="create.tenant_description"
                /> -->
                <!-- <textarea v-model="create.tenant_description" /> -->
                <!-- <textarea
                  v-model="create.tenant_description"
                  @keyup="tenantDescriptionChange"
                  rows="5"
                  class="w-full pl-3 pr-3 py-2 rounded-md border-2 focus:outline-none focus:ring transition duration-200"
                  :class="[
                    errors.tenant_description
                      ? 'border-red-400 focus:ring-red-200'
                      : 'border-gray-200 focus:ring-blue-200',
                  ]"
                  placeholder="Description"
                >
                </textarea> -->
                <div
                  class="text-right text-sm "
                  :class="[
                    create?.tenant_description?.length <= 2000
                      ? 'text-gray-600'
                      : 'text-red-600',
                  ]"
                >
                  {{ create?.tenant_description?.length }} used out of 2000
                  characters
                </div>
                <div class="text-sm text-red-600 mb-5">
                  {{ errors.tenant_description_msg }}
                </div>
              </div>
            </div>
          </div>
          <div class="px-6 py-3 border-t">
            <div class="flex justify-end">
              <button
                @click.self="closeModalTenant"
                type="button"
                class="bg-gray-700 text-gray-100 rounded px-4 py-2 mr-1"
              >
                Cancel
              </button>
              <!-- :disabled="locationFileList.length === 0 && previewFileTenant.length === 0" -->
              <button
                @click="saveTenant"
                type="button"
                class="bg-blue-600 text-gray-200 rounded px-4 py-2 w-32"
              >
                {{ saveButton }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        @click.self="closeModalTenant"
        class="z-40 overflow-auto left-0 top-0 bottom-0 right-0 w-full h-full fixed bg-black opacity-50"
      ></div>
    </div>
    <Modal v-show="isModalVisible" @close="closeModal" :imageso="imageso" />
    <WarningTenant />
    <SuccessNotif />
  </main>
</template>

<script>
import API from "../../api";
import Modal from "../../components/Modal.vue";
import CKEditor from "../../components/CKEditor.vue";
import Select from "../../components/Select.vue";
import WarningTenant from "../../components/WarningTenant.vue";
import SuccessNotif from "../../components/SuccessNotif.vue";
export default {
  name: "Tenant",
  components: {
    Select,
    Modal,
    WarningTenant,
    SuccessNotif,
    CKEditor,
  },
  data() {
    return {
      // tenan_category: [],
      // floors: [],
      imageso: "",
      toolbar: {
        items: [
          "bold",
          "italic",
          "underline",
          "|",
          "superscript",
          "subscript",
          "strikethrough",
          "|",
          "outdent",
          "indent",
          "alignment",
          "|",
          "undo",
          "redo",
        ],
      },
      modalBanner: false,
      tenantBanner: {},
      isModalVisible: false,
      update: {
        previewBanner: null,
        fileBanner: null,
      },
      table: {
        current_page: 1,
        per_page: 10,
        search: "",
        total: 0,
      },
      dropDown: {
        isOpen: false,
        dataSelect: [],
        title: "Tenant Category",
        selected: "pilih sesuatu",
      },
      floorDropDown: {
        isOpen: false,
        dataSelect: [],
        title: "Floor Location",
        selected: "pilih sesuatu",
      },
      previewFileTenant: null,
      tenantFileList: null,
      previewFileLocation: null,
      locationFileList: null,
      errors: {
        user_id: false,
        tenant_image: false,
        tenant_denah_position: false,
        tenan_category_id: false,
        tenant_name: false,
        tenant_telephone: false,
        tenant_email: false,
        tenant_website: false,
        tenant_website_mall_to_go: false,
        tenant_description: false,
        tenant_floor_location: false,
        is_active: false,
        user_id_msg: "",
        tenant_image_msg: "",
        tenant_denah_position_msg: "",
        tenan_category_id_msg: "",
        tenant_name_msg: "",
        tenant_telephone_msg: "",
        tenant_email_msg: "",
        tenant_website_msg: "",
        tenant_website_mall_to_go_msg: "",
        tenant_description_msg: "",
        tenant_floor_location_msg: "",
        is_active_msg: "",
      },
      create: {
        tenan_category_id: null,
        tenant_name: "",
        tenant_telephone: "",
        tenant_email: "",
        tenant_website: "",
        tenant_website_mall_to_go: "",
        tenant_description: "",
        tenant_floor_location: null,
        tenant_active: true,
        user_id: null,
      },
      modalTenant: false,
      title: "",
      rows: [],
      id: null,
      user_id: null,
      saveButton: "Save",
      deleteButton: "Delete",
    };
  },
  methods: {
    showModal: function(data) {
      this.imageso = data;
      this.isModalVisible = true;
    },
    closeModal: function() {
      this.isModalVisible = false;
    },
    openSelect: function() {
      this.dropDown.isOpen = !this.dropDown.isOpen;
    },
    selectItem: function(val) {
      this.dropDown.isOpen = false;
      this.create.tenan_category_id = val.id;
      this.errors.tenan_category_id = false;
      this.errors.tenan_category_id_msg = "";
      this.dropDown.selected = val.name;
    },
    floorOpenSelect: function() {
      this.floorDropDown.isOpen = !this.floorDropDown.isOpen;
    },
    floorSelectItem: function(val) {
      this.floorDropDown.isOpen = false;
      this.create.tenant_floor_location = val.id;
      this.errors.tenant_floor_location_msg = "";
      this.errors.tenant_floor_location = false;
      this.floorDropDown.selected = val.name;
    },
    tenantNameChange: function(e) {
      this.create.tenant_name = e.target.value;
      this.errors.tenant_name = false;
      this.errors.tenant_name_msg = "";
    },
    tenantTelephoneChange: function(e) {
      this.create.tenant_telephone = e.target.value;
      this.errors.tenant_telephone = false;
      this.errors.tenant_telephone_msg = "";
    },
    tenantEmailChange: function(e) {
      this.create.tenant_email = e.target.value;
      this.errors.tenant_email = false;
      this.errors.tenant_email_msg = "";
    },
    tenantWebsiteChange: function(e) {
      this.create.tenant_website = e.target.value;
      this.errors.tenant_website = false;
      this.errors.tenant_website_msg = "";
    },
    tenantWebsiteMallToGoChange: function(e) {
      this.create.tenant_website_mall_to_go = e.target.value;
      this.errors.tenant_website_mall_to_go = false;
      this.errors.tenant_website_mall_to_go_msg = "";
    },
    tenantDescriptionChange: function() {
      // this.create.tenant_description = e.target.value;
      this.errors.tenant_description = false;
      this.errors.tenant_description_msg = "";
    },
    searchSubscriber: function() {
      this.current_page = 1;
      this.per_page = 10;
      this.findTenant();
    },
    nexPage: function() {
      this.table.current_page = this.table.current_page + 1;
      this.findTenant();
    },
    previewPage: function() {
      this.table.current_page = this.table.current_page - 1;
      this.findTenant();
    },
    findpage: function(page) {
      this.table.current_page = page;
      this.findTenant();
    },
    chooseSingleFile: function() {
      document.getElementById("tenant_file").click();
    },
    removeTenantFile: function() {
      this.previewFileTenant = null;
      this.tenantFileList = null;
    },
    chooseFileLocation: function() {
      document.getElementById("location_file").click();
    },
    removeFileLocation: function() {
      this.locationFileList = null;
      this.previewFileLocation = null;
    },
    detailContent: function(id) {
      this.$router.push(this.$route.path + "/" + id);
    },
    showModalBanner: function() {
      this.modalBanner = !this.modalBanner;
    },
    previewBanner: function(event) {
      let input = event.target;
      if (input.files) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.update.previewBanner = e.target.result;
        };
        this.update.fileBanner = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
    },
    removeBannerFile: function() {
      this.update.previewBanner = null;
      this.update.fileBanner = null;
    },
    chooseBannerFile: function() {
      document.getElementById("banner").click();
    },
    updateBannerTenant: async function() {
      this.saveButton = "Loading...";
      let formdata = new FormData();
      formdata.append("banner", this.update.fileBanner);
      formdata.append("id", this.tenantBanner.id);
      try {
        let res = await fetch(`${API}v1/admin/cms/tenants/header/update`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        const response = await res.json();
        if (response.status !== 200) {
          this.modalBanner = false;
          this.saveButton = "Save";
          this._error(response.message);
          return;
        }
        this.modalBanner = false;
        this.findTenantBanner();
        this.saveButton = "Save";
        this._success("Data updated.");
      } catch (err) {
        this.modalBanner = false;
        this.saveButton = "Save";
        this._error("internal server error");
      }
    },
    findTenantBanner: async function() {
      try {
        let res = await fetch(`${API}v1/tenant_banner`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error(respon.message);
          return;
        }
        this.tenantBanner = respon.data;
      } catch (err) {
        this._error("internal server error");
      }
    },
    previewImageTenant: function(event) {
      let input = event.target;
      if (input.files[0]) {
        let type = "image/jpeg, image/jpg";
        if (!type.includes(input.files[0].type)) {
          this._error("Please use jpeg or jpg image");
          return;
        }
      }
      if (input.files) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.previewFileTenant = e.target.result;
        };
        this.tenantFileList = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
      this.errors.tenant_image = false;
      this.errors.tenant_image_msg = "";
    },
    previewImageLocation: function(event) {
      let input = event.target;
      if (input.files[0]) {
        let type = "image/jpeg, image/jpg";
        if (!type.includes(input.files[0].type)) {
          this._error("Please use jpeg or jpg image");
          return;
        }
      }
      if (input.files) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.previewFileLocation = e.target.result;
        };
        this.locationFileList = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
      this.errors.tenant_denah_position = false;
      this.errors.tenant_denah_position_msg = "";
    },
    showModalTenant: function() {
      this.title = "Create New Tenant";
      this.create = {
        tenan_category_id: null,
        tenant_name: "",
        tenant_telephone: "",
        tenant_email: "",
        tenant_website: "",
        tenant_website_mall_to_go: "",
        tenant_description: "",
        tenant_floor_location: null,
        tenant_active: true,
        user_id: null,
      };
      this.previewFileTenant = null;
      this.tenantFileList = null;
      this.previewFileLocation = null;
      this.locationFileList = null;
      this.modalTenant = true;
    },
    closeModalTenant: function() {
      this.modalTenant = false;
    },
    findTenant: async function() {
      try {
        let res = await fetch(
          `${API}v1/tenants?current_page=${this.table.current_page}&per_page=${this.table.per_page}&search=${this.table.search}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.rows = respon.data.tenants;
        this.table.current_page = respon.data.current_page;
        this.table.per_page = respon.data.per_page;
        // this.table.search = respon.data.search
        this.table.total = respon.data.total;
      } catch (err) {
        this._error("internal server error");
      }
    },
    findCategoryTenant: async function() {
      try {
        let res = await fetch(`${API}v1/tenant-category`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.dropDown.dataSelect = respon.data.map((itm) => {
          return {
            id: itm.id,
            name: itm.tenan_category_name,
          };
        });
      } catch (err) {
        this._error("internal server error");
      }
    },
    findFloors: async function() {
      try {
        let res = await fetch(`${API}v1/floors`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
        let respon = await res.json();
        if (respon.status !== 200) {
          this._error("internal server error");
          return;
        }
        this.floorDropDown.dataSelect = respon.data.map((itm) => {
          return {
            id: itm.id,
            name: itm.floor_name,
          };
        });
      } catch (err) {
        this._error("internal server error");
      }
    },
    saveTenant: async function() {
      this.saveButton = "Loading...";
      let formdata = new FormData();
      formdata.append("tenan_category_id", this.create.tenan_category_id);
      formdata.append("tenant_name", this.create.tenant_name);
      formdata.append("tenant_telephone", this.create.tenant_telephone);
      formdata.append("tenant_email", this.create.tenant_email);
      formdata.append("tenant_website", this.create.tenant_website);
      formdata.append(
        "tenant_website_mall_to_go",
        this.create.tenant_website_mall_to_go
      );
      formdata.append("tenant_image", this.tenantFileList);
      formdata.append("tenant_denah_position", this.locationFileList);
      formdata.append("tenant_description", this.create.tenant_description);
      formdata.append(
        "tenant_floor_location",
        this.create.tenant_floor_location
      );
      formdata.append("is_active", this.create.tenant_active);
      formdata.append(
        "user_id",
        this.$store.state.profile.id === undefined
          ? 1
          : this.$store.state.profile.id
      );
      try {
        let res = await fetch(`${API}v1/admin/cms/tenants/store`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
          body: formdata,
        });
        const response = await res.json();
        if (response.status !== 200) {
          if (response.message === "ERR_FORM") {
            response.data.map((item) => {
              if (item.key === "tenant_image") {
                this.errors.tenant_image = true;
                this.errors.tenant_image_msg = item.message;
              }
              if (item.key === "tenant_denah_position") {
                this.errors.tenant_denah_position = true;
                this.errors.tenant_denah_position_msg = item.message;
              }
              if (item.key === "user_id") {
                this.errors.user_id = true;
                this.errors.user_id_msg = item.message;
              }
              if (item.key === "tenan_category_id") {
                this.errors.tenan_category_id = true;
                this.errors.tenan_category_id_msg = item.message;
              }
              if (item.key === "tenant_name") {
                this.errors.tenant_name = true;
                this.errors.tenant_name_msg = item.message;
              }
              if (item.key === "tenant_telephone") {
                this.errors.tenant_telephone = true;
                this.errors.tenant_telephone_msg = item.message;
              }
              if (item.key === "tenant_email") {
                this.errors.tenant_email = true;
                this.errors.tenant_email_msg = item.message;
              }
              if (item.key === "tenant_website") {
                this.errors.tenant_website = true;
                this.errors.tenant_website_msg = item.message;
              }
              if (item.key === "tenant_website_mall_to_go") {
                this.errors.tenant_website_mall_to_go = true;
                this.errors.tenant_website_mall_to_go_msg = item.message;
              }
              if (item.key === "tenant_description") {
                this.errors.tenant_description = true;
                this.errors.tenant_description_msg = item.message;
              }
              if (item.key === "tenant_floor_location") {
                this.errors.tenant_floor_location = true;
                this.errors.tenant_floor_location_msg = item.message;
              }
              if (item.key === "is_active") {
                this.errors.is_active = true;
                this.errors.is_active_msg = item.message;
              }
            });
            this.saveButton = "Save";
            return;
          }
          this.saveButton = "Save";
          return;
        }
        this.modalTenant = false;
        this.findTenant();
        this._success("Data has been saved.");
      } catch (err) {
        this.saveButton = "Save";
        this._error("internal server error");
      }
    },
    _error: function(message) {
      this.$store.dispatch("warning", {
        isError: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("warning", {
          isError: false,
          message: "",
        });
      }, 5000);
    },
    _success: function(message) {
      this.$store.dispatch("success", {
        isSuccess: true,
        message: message,
      });
      setTimeout(() => {
        this.$store.dispatch("success", {
          isSuccess: false,
          message: "",
        });
      }, 5000);
    },
  },
  created: function() {
    this.findTenantBanner();
    this.findTenant();
    this.findCategoryTenant();
    this.findFloors();
  },
};
</script>
